import {
  Illustration,
  Mono,
  ink,
  label,
  structure,
  surface,
  surfaceMuted,
  pass,
  warn,
  fail,
} from './primitives'

/**
 * Portfolio compliance posture as a product-screenshot-style panel: a donut of
 * status distribution + a small stat column + a coverage bar per status.
 * Illustrative portfolio numbers only.
 */
export function CompliancePosture({ className }: { className?: string }) {
  // 142 vendors: 128 compliant, 9 expiring, 5 action
  const total = 142
  const seg = [
    { v: 128, c: pass, label: 'Compliant' },
    { v: 9, c: warn, label: 'Expiring soon' },
    { v: 5, c: fail, label: 'Action required' },
  ]
  const cx = 90
  const cy = 100
  const r = 58
  const circ = 2 * Math.PI * r
  let offset = 0

  return (
    <Illustration
      viewBox="0 0 560 200"
      className={className}
      title="Compliance posture: 142 vendors, 128 compliant, 9 expiring, 5 action required"
    >
      {/* panel */}
      <rect x={8} y={8} width={544} height={184} rx={14} fill={surface} stroke={structure} strokeWidth={1.5} />
      <Mono x={28} y={34} size={10} fill={label} weight={600}>PORTFOLIO POSTURE</Mono>

      {/* donut */}
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={surfaceMuted} strokeWidth={16} />
      {seg.map((s, i) => {
        const frac = s.v / total
        const dash = frac * circ
        const el = (
          <circle
            key={i}
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke={s.c}
            strokeWidth={16}
            strokeDasharray={`${dash} ${circ - dash}`}
            strokeDashoffset={-offset}
            transform={`rotate(-90 ${cx} ${cy})`}
            strokeLinecap="butt"
          />
        )
        offset += dash
        return el
      })}
      <text x={cx} y={cy - 2} textAnchor="middle" fill={ink} fontSize={30} fontWeight={600} fontFamily="'Geist Variable', system-ui, sans-serif" className="tnum">{total}</text>
      <Mono x={cx} y={cy + 18} anchor="middle" size={10} fill={label}>VENDORS</Mono>

      {/* legend + bars */}
      {seg.map((s, i) => {
        const y = 44 + i * 42
        const barW = (s.v / total) * 220
        return (
          <g key={s.label}>
            <circle cx={210} cy={y + 8} r={5} fill={s.c} />
            <text x={224} y={y + 12} fill={ink} fontSize={13} fontWeight={600} fontFamily="'Geist Variable', system-ui, sans-serif">{s.label}</text>
            <text x={524} y={y + 12} textAnchor="end" fill={ink} fontSize={13} fontWeight={600} fontFamily="'Geist Variable', system-ui, sans-serif" className="tnum">{s.v}</text>
            <rect x={224} y={y + 20} width={300} height={6} rx={3} fill={surfaceMuted} />
            <rect x={224} y={y + 20} width={Math.max(barW, 6)} height={6} rx={3} fill={s.c} />
          </g>
        )
      })}
    </Illustration>
  )
}
